import { useEffect } from 'react';
import { initCA } from '@vp/chat-anywhere';
import { initChatbot } from '@vp/chatbot-ui';
import { isFeatureEnabled, initialize, whenAvailable } from '@vp/ab-reader';
export const useChatAnywhere = ({ locale, pageName, tenant }) => {
  useEffect(() => {
    try {
      initialize();
      whenAvailable((available) => {
        if (available && isFeatureEnabled('ca-chatbot-ubik')) {
          initChatbot({
            locale: locale,
            pageName: pageName,
            tenant: tenant || 'vistaprint',
          });
        } else {
          initCA();
        }
      }, 1000);
    } catch (error) {
      console.warn('Chat anywhere package could not be loaded', error);
    }
  }, [locale, pageName, tenant]);

};
